export default "__VITE_ASSET__DbqkGCnY__"